import { ADMIN_MODAL_TYPE } from '@data'
import { PATIENT_MODAL_TYPE, useModalStore } from '@modal'
import { Button, Modal, RadioBtn, SmallText, TextAreaField } from '@ui'
import { Box } from 'grommet'
import { Close } from 'grommet-icons'
import { ChangeEvent, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

type Props = {
  onClose: () => void
  id?: string
  showStaff?: boolean
  type?: 'staff' | 'patient'
}

export const CancelAppointment = ({ onClose, id = '', showStaff = true, type: defaultType = 'staff' }: Props) => {
  const methods = useForm()
  const { openModal } = useModalStore()
  const [type, setType] = useState(defaultType)

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setType(event.target?.value as 'staff' | 'patient')
  }

  const onSubmit = (formVal: Record<string, unknown>) => {
    if (defaultType === 'staff') {
      openModal(ADMIN_MODAL_TYPE.REMOVE_APPOINTMENT, {
        id,
        defaultData: { ...formVal, cancelled_by: type }
      })
    } else {
      console.log(formVal)
      openModal(PATIENT_MODAL_TYPE.REMOVE_APPOINTMENT, {
        id,
        defaultData: { ...formVal, cancelled_by: type }
      })
    }
    onClose()
  }

  return (
    <Modal onClose={onClose} title="Cancel Appointment">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <Box flex overflow="auto" pad="xsmall">
            <Box flex={false} gap="20px" overflow="auto" pad={{ horizontal: '32px', vertical: '16px' }}>
              {showStaff && (
                <Box margin={{ bottom: '36px' }} pad="0">
                  <SmallText margin={{ bottom: '12px' }}>Who is cancelling the appointment ?</SmallText>
                  <Box gap="14px" pad="0">
                    <Box direction="row" justify="between" pad="0">
                      <SmallText>Staff</SmallText>
                      <RadioBtn checked={type === 'staff'} name="type" onChange={handleChange} value="staff" />
                    </Box>
                    <Box direction="row" justify="between" pad="0">
                      <SmallText>Patient</SmallText>
                      <RadioBtn checked={type === 'patient'} name="type" onChange={handleChange} value="patient" />
                    </Box>
                  </Box>
                </Box>
              )}
              <Box pad="0">
                <SmallText margin={{ bottom: '8px' }}>Reasons</SmallText>
                <TextAreaField
                  name="cancel_reason"
                  placeholder="Why is the appointment being cancelled"
                  style={{ minHeight: showStaff ? 180 : 250, padding: '12px' }}
                />
              </Box>
            </Box>
          </Box>
          <Box
            align="center"
            as="footer"
            border={{ side: 'top', size: 'xsmall' }}
            direction="row"
            flex={false}
            height="100px"
            pad={{ horizontal: '32px' }}
            width="100%"
          >
            <Box flex>
              <Button
                icon={<Close color="white" size="small" />}
                isLoading={methods.formState.isSubmitting}
                label="Cancel Appointment"
                style={{ backgroundColor: '#D95069', color: 'white', fontSize: '16px', fontWeight: 'normal' }}
                type="submit"
              />
            </Box>
          </Box>
        </form>
      </FormProvider>
    </Modal>
  )
}

export default CancelAppointment
